import type { IndicatorName } from "./types";
import type { IndicatorSettings } from "./indicatorSettings";
import { INDICATOR_DEFAULTS_EXTENDED } from "./indicatorDefaultsExtended";

export const INDICATOR_DEFAULT_SETTINGS: Partial<Record<IndicatorName, IndicatorSettings>> = {
  ...INDICATOR_DEFAULTS_EXTENDED,
  acceleratorOscillator: {
    aoShortPeriod: 5,
    aoLongPeriod: 34,
    acSmaPeriod: 5,
    mainLineVisible: true,
    mainLineOpacity: 100,
    upColor: "#22c55e",
    downColor: "#ef4444",
  },
  aDX: {
    adxSmoothing: 14,
    diLength: 14,
    adx: { visible: true, color: "#ef4444", width: 1 },
    plusDI: { visible: true, color: "#3b82f6", width: 1 },
    minusDI: { visible: true, color: "#eab308", width: 1 },
  },
  donchianChannel: {
    period: 20,
    middle: { visible: true, color: "#f97316", width: 1 },
    top: { visible: true, color: "#3b82f6", width: 1 },
    bottom: { visible: true, color: "#3b82f6", width: 1 },
    background: { visible: true, color: "#3b82f6" },
  },
  bollingerBands: {
    period: 5,
    deviation: 1,
    top: { visible: true, color: "#22c55e", width: 1 },
    middle: { visible: true, color: "#3b82f6", width: 1 },
    bottom: { visible: true, color: "#eab308", width: 1 },
    background: { visible: true, color: "#22c55e" },
  },
  aroon: {
    period: 25,
    up: { visible: true, color: "#3b82f6", width: 1 },
    down: { visible: true, color: "#ef4444", width: 1 },
  },
  alligator: {
    jawsPeriod: 13,
    jawsShift: 8,
    teethPeriod: 8,
    teethShift: 5,
    lipsPeriod: 5,
    lipsShift: 3,
    jaws: { visible: true, color: "#3b82f6", width: 1 },
    teeth: { visible: true, color: "#ef4444", width: 1 },
    lips: { visible: true, color: "#22c55e", width: 1 },
  },
  fractal: {
    period: 2,
    up: { visible: true, color: "#22c55e" },
    down: { visible: true, color: "#ef4444" },
  },
  fractalChaosBands: {
    period: 2,
    up: { visible: true, color: "#22c55e" },
    down: { visible: true, color: "#ef4444" },
    background: { visible: true, color: "#22c55e" },
  },
};
